export default "__VITE_ASSET__D3fn7bYT__"